<template>
  <template v-if="!props.to">
    <button :type="props.type" :disabled="disabled">
      <slot />
    </button>
  </template>
  <template v-else>
    <router-link :to="props.to" :disabled="disabled">
      <slot />
    </router-link>
  </template>
</template>

<script setup>
import { computed } from 'vue'

import { useCommonStore } from '@/store/common'

const props = defineProps({
  type: {
    type: String,
    default: 'button',
  },
  to: {
    default: null,
  },
})

const commonStore = useCommonStore()

const disabled = computed(() => commonStore.buttonDisabled)
</script>
